export const EMAIL_REGEX =
  /^([a-zA-Z0-9_\-+.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,})$/;

export const COCHLEAR_ID_REGEX = /^[0-9]{15}$/;

export const DEFAULT_FLAGS = {
  featureEnabler: {
    advancedSearch: true,
    clinicAdmin: true,
    simpleSearch: true,
    viewPatient: true,
    createPatient: true,
    deviceRegistration: true,
    programFileRequests: true,
    amazonConnectChat: false,
  },
};

export const MASHUP_PAGES = [
  'home',
  'clinic-equipment',
  'cpn-resource',
  'resources',
  'patients',
];
